module.exports = __webpack_public_path__ + "media/images/next-e0c8f205ff850c536705745ed425652e.svg";